import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataIndicesHub() {
  return <SectionHub sectionPath="01-market-data/indices" />;
}
